var _circle, _circle2, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "url(#paint0_linear_4950_36198)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "black",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1205 12.6393H8.04864C8.05667 11.9165 8.11289 11.2941 8.21729 10.7721C8.32972 10.242 8.51845 9.76418 8.78348 9.33853C9.05653 8.91289 9.41793 8.49126 9.86767 8.07364C10.2451 7.73634 10.5744 7.4151 10.8555 7.10992C11.1366 6.80474 11.3574 6.49153 11.518 6.17029C11.6787 5.84102 11.759 5.47561 11.759 5.07405C11.759 4.60825 11.6867 4.22277 11.5421 3.91759C11.4056 3.60438 11.1968 3.36746 10.9157 3.20684C10.6427 3.04622 10.2973 2.96591 9.87971 2.96591C9.53438 2.96591 9.21314 3.0422 8.91599 3.19479C8.61884 3.33935 8.37389 3.56422 8.18115 3.8694C7.99644 4.17458 7.90006 4.57613 7.89203 5.07405H4.39853C4.42263 3.9738 4.6756 3.0663 5.15747 2.35153C5.64736 1.62874 6.30189 1.09468 7.12105 0.749344C7.94022 0.395978 8.85977 0.219296 9.87971 0.219296C11.0041 0.219296 11.9678 0.404009 12.7709 0.773437C13.574 1.13483 14.1884 1.6689 14.614 2.37563C15.0397 3.07433 15.2525 3.92562 15.2525 4.9295C15.2525 5.6282 15.1159 6.2506 14.8429 6.79671C14.5698 7.33479 14.2125 7.83673 13.7707 8.30253C13.329 8.76833 12.8432 9.25019 12.3131 9.74811C11.8553 10.1577 11.5421 10.5874 11.3735 11.0371C11.2129 11.4868 11.1285 12.0209 11.1205 12.6393ZM7.68724 16.3617C7.68724 15.8477 7.86392 15.422 8.21729 15.0847C8.57065 14.7394 9.04449 14.5667 9.63878 14.5667C10.225 14.5667 10.6949 14.7394 11.0482 15.0847C11.4096 15.422 11.5903 15.8477 11.5903 16.3617C11.5903 16.8596 11.4096 17.2812 11.0482 17.6266C10.6949 17.9719 10.225 18.1446 9.63878 18.1446C9.04449 18.1446 8.57065 17.9719 8.21729 17.6266C7.86392 17.2812 7.68724 16.8596 7.68724 16.3617Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4950_36198",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7721E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#7721E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E06D6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.d542211955a2a71d7de2d894c6c65ae5.svg";
export { ForwardRef as ReactComponent };